module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0823d90f9e418868c7fea7d82573d656.png";